export function renderDefaultValueChangeHandler({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(value) => {
${indent}            ${defaultValueFromHandler}(value)
${indent}            formField.onChange(value)
${indent}          }`
}
